import { render, staticRenderFns } from "./Variacoes.vue?vue&type=template&id=146aa36e&scoped=true&lang=pug"
import script from "./Variacoes.vue?vue&type=script&lang=js"
export * from "./Variacoes.vue?vue&type=script&lang=js"
import style0 from "./Variacoes.vue?vue&type=style&index=0&id=146aa36e&prod&lang=scss"
import style1 from "./Variacoes.vue?vue&type=style&index=1&id=146aa36e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "146aa36e",
  null
  
)

export default component.exports